import Snackbar from '@material-ui/core/Snackbar';
import React from 'react';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import withStyles from '@material-ui/styles/withStyles';
import { green, red, yellow } from '@material-ui/core/colors';
import { useQuery, useApolloClient } from '@apollo/react-hooks';
import { GET_SNACKBAR_STATE } from '../../graphql/common/snackbar/query';

const styles = () => ({
  snackSuccess: {
    backgroundColor: green[600],
  },

  snackError: {
    backgroundColor: red[600],
  },

  snackInfo: {
    backgroundColor: yellow[600],
  },
});

const GlobalSnackBar = (props: any) => {
  const { classes } = props;
  const client = useApolloClient();
  const closeSnack = () => {
    client.writeData({
      data: {
        snackBar: {
          isOpen: false,
          __typename: 'SnackBar',
        },
      },
    });
  };

  const { data } = useQuery(GET_SNACKBAR_STATE, { fetchPolicy: 'cache-only' });

  if (data) {
    const { isOpen, message, type } = data.snackBar
      ? data.snackBar
      : { isOpen: false, message: '', type: 'ERROR' };

    const mapType = (typeParam: 'ERROR' | 'SUCCESS' | 'INFO') => {
      switch (typeParam) {
        case 'SUCCESS':
          return classes.snackSuccess;

        case 'INFO':
          return classes.snackInfo;

        case 'ERROR':
          return classes.snackError;
      }
    };

    return (
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={isOpen}
        autoHideDuration={5000}
        onClose={closeSnack}>
        <SnackbarContent
          onClick={closeSnack}
          className={mapType(type)}
          message={message}
        />
      </Snackbar>
    );
  }
  return null;
};

export default withStyles(styles)(GlobalSnackBar);
